module.exports = __webpack_public_path__ + "c198531db1ee507ce2bda2fd116796b2.MP3";